(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.price').forEach(el => {
    if (el.innerText.includes('0,00')) {
      el.style.display = 'none';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
